
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b60877585 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1636765615 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b2080184443 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1045048052 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b151039517 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.a1372762224 = messageFormatterFn((function(  ) {
  return function(d) { return "Reizen: Vakanties, Goedkope vluchten en Vliegtickets"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1921050888 = messageFormatterFn((function(  ) {
  return function(d) { return "Punten toegepast"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a998401067 = messageFormatterFn((function(  ) {
  return function(d) { return "Punten niet toegepast"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1292233711 = messageFormatterFn((function(  ) {
  return function(d) { return "Venster sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1430725682 = messageFormatterFn((function(  ) {
  return function(d) { return "Naar"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1849044936 = messageFormatterFn((function(  ) {
  return function(d) { return "Inchecken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1626427495 = messageFormatterFn((function(  ) {
  return function(d) { return "Uitchecken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a914565510 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b482473232 = messageFormatterFn((function(  ) {
  return function(d) { return "Gasten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a299609366 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoeken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a244368544 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer info over " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1008183107 = messageFormatterFn((function(  ) {
  return function(d) { return "Opent " + d["0"] + " in een nieuw tabblad. Ga terug naar het oorspronkelijke tabblad om verder te gaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1473676584 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoekresultaten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1500462519 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een bestemming in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a299197327 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een geldige incheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a353754896 = messageFormatterFn((function(  ) {
  return function(d) { return "Datums voor je reis selecteren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a820094006 = messageFormatterFn((function(  ) {
  return function(d) { return "De uitcheckdatum moet na de incheckdatum vallen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1790445630 = messageFormatterFn((function(  ) {
  return function(d) { return "De uitcheckdatum moet binnen 28 dagen na de incheckdatum vallen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2085304414 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een geldige uitcheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1698482356 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer het aantal reizigers"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1555771883 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de leeftijd in van het meereizende kind"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a276622181 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de leeftijd in van de meereizende kinderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b188662141 = messageFormatterFn((function(  ) {
  return function(d) { return "Verblijfdatums dienen tussen de reisdatums te vallen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b960562968 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b477455430 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " kamers";}, one: function() { return number(d["0"]) + " kamer";}, two: function() { return number(d["0"]) + " kamers";}, few: function() { return number(d["0"]) + " kamers";}, many: function() { return number(d["0"]) + " kamers";}, other: function() { return number(d["0"]) + " kamers";} }) + ", " + plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1507167734 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b809174360 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }) + ", huisdieren"; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1636803463 = messageFormatterFn((function(  ) {
  return function(d) { return "Gasten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a937546917 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer " + d["0"] + " toegevoegd. Bewerk hieronder de gastengegevens."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1892303995 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer verwijderd. Bewerk hieronder de gastengegevens voor kamer " + d["0"] + "."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1260925985 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren, sluit de Reizigerskeuze zonder de wijzigingen op te slaan. Of bewerk de onderstaande gastengegevens."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1244492961 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a793082409 = messageFormatterFn((function(  ) {
  return function(d) { return "Bewaar de wijzigingen en sluit de Reizigerskeuze."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b502578269 = messageFormatterFn((function(  ) {
  return function(d) { return "Nog een kamer toevoegen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a941118686 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1880880102 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer " + d["0"] + " van " + d["1"] + " verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a245795452 = messageFormatterFn((function(  ) {
  return function(d) { return "Leeftijd kind " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1146639500 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a845652971 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer " + d["0"] + " van " + d["1"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a348567347 = messageFormatterFn((function(  ) {
  return function(d) { return "Kind " + d["0"] + ", Leeftijd is nu " + d["1"] + "."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a928165081 = messageFormatterFn((function(  ) {
  return function(d) { return "< 1"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1615711211 = messageFormatterFn((function(  ) {
  return function(d) { return "Kinderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b504000386 = messageFormatterFn((function(  ) {
  return function(d) { return "(0 t/m 17 jaar)"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b629506817 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " volwassenen";}, one: function() { return number(d["0"]) + " volwassene";}, two: function() { return number(d["0"]) + " volwassenen";}, few: function() { return number(d["0"]) + " volwassenen";}, many: function() { return number(d["0"]) + " volwassenen";}, other: function() { return number(d["0"]) + " volwassenen";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1705563333 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " kinderen";}, one: function() { return number(d["0"]) + " kind";}, two: function() { return number(d["0"]) + " kinderen";}, few: function() { return number(d["0"]) + " kinderen";}, many: function() { return number(d["0"]) + " kinderen";}, other: function() { return number(d["0"]) + " kinderen";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1780735055 = messageFormatterFn((function(  ) {
  return function(d) { return "Volwassenen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b149555347 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal kinderen in kamer " + d["0"] + " verlagen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b933410893 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal volwassenen in kamer " + d["0"] + " verlagen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a616662345 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal kinderen in kamer " + d["0"] + " verhogen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a738892943 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal volwassenen in kamer " + d["0"] + " verhogen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1559241243 = messageFormatterFn((function(  ) {
  return function(d) { return "Huisdieren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b315194495 = messageFormatterFn((function(  ) {
  return function(d) { return "Huisdieren inbegrepen?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1153089461 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a41206887 = messageFormatterFn((function(  ) {
  return function(d) { return "Nee"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1233084687 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is opgeslagen in je lijsten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1556734731 = messageFormatterFn((function(  ) {
  return function(d) { return "Opent een nieuw venster"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1817914016 = messageFormatterFn((function(  ) {
  return function(d) { return "Gastenbeoordelingen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b264592856 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren, ga terug naar hoteldetails."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1762698032 = messageFormatterFn((function(  ) {
  return function(d) { return "Beschikbaarheid controleren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1960305371 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarieven controleren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1694211991 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoekopdracht wijzigen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b997409068 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een latere incheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a57024304 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een eerdere incheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b399659125 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een latere uitcheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a654774247 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een eerdere uitcheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a144264639 = messageFormatterFn((function(  ) {
  return function(d) { return "De prijs was " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a446829007 = messageFormatterFn((function(  ) {
  return function(d) { return "De prijs is " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a918588020 = messageFormatterFn((function(  ) {
  return function(d) { return "De huidige prijs is " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b760357182 = messageFormatterFn((function(  ) {
  return function(d) { return "De prijs was " + d["0"] + ", de prijs is nu " + d["1"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1350091291 = messageFormatterFn((function(  ) {
  return function(d) { return "per nacht"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b152550293 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren, ga terug naar hoteldetails."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a89569091 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer info"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b806277299 = messageFormatterFn((function(  ) {
  return function(d) { return "Sluiten, ga terug naar hoteldetails."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b758107401 = messageFormatterFn((function(  ) {
  return function(d) { return "Er deed zich een fout voor."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a607678129 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer een nieuwe zoekopdracht."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a414603321 = messageFormatterFn((function(  ) {
  return function(d) { return "Opties bekijken en boeken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1382125009 = messageFormatterFn((function(  ) {
  return function(d) { return "Doorgaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b986328876 = messageFormatterFn((function(  ) {
  return function(d) { return "Misschien vind je dit ook leuk"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1924784019 = messageFormatterFn((function(  ) {
  return function(d) { return "Wat je ziet, is wat je betaalt"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a423456754 = messageFormatterFn((function(  ) {
  return function(d) { return "De totaalprijs is inclusief alle belastingen en toeslagen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1915316729 = messageFormatterFn((function(  ) {
  return function(d) { return "Filters sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1738583311 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorteeropties & filters"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a243303215 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a454473116 = messageFormatterFn((function(  ) {
  return function(d) { return "Wissen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1531790131 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik op toepassen of ga terug om filters te sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a648026037 = messageFormatterFn((function(  ) {
  return function(d) { return "Minimumprijs"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b231131577 = messageFormatterFn((function(  ) {
  return function(d) { return "Maximumprijs"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a468339796 = messageFormatterFn((function(  ) {
  return function(d) { return "Sterrenclassificatie"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b517232797 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorteren op"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1323183900 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter op"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1877134884 = messageFormatterFn((function(  ) {
  return function(d) { return "Terug naar zoekresultaten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b343506798 = messageFormatterFn((function(  ) {
  return function(d) { return "We zoeken door duizenden accommodaties"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1645894381 = messageFormatterFn((function(  ) {
  return function(d) { return "Aan het zoeken naar duizenden pakketdeals"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b771927941 = messageFormatterFn((function(  ) {
  return function(d) { return "We vergelijken prijzen van populaire autoverhuurbedrijven om je de beste deals aan te bieden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1238512284 = messageFormatterFn((function(  ) {
  return function(d) { return "Aan het schakelen om de beste deals voor huurauto's voor je te vinden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1793717567 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " filters";}, one: function() { return number(d["0"]) + " filter";}, two: function() { return number(d["0"]) + " filters";}, few: function() { return number(d["0"]) + " filters";}, many: function() { return number(d["0"]) + " filters";}, other: function() { return number(d["0"]) + " filters";} }) + " toegepast"; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b317336831 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorteeropties & filters"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a497582379 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1521349342 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaart"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2124322148 = messageFormatterFn((function(  ) {
  return function(d) { return "Direct door naar kaart"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b545415617 = messageFormatterFn((function(  ) {
  return function(d) { return "resultaten worden geladen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b330903328 = messageFormatterFn((function(  ) {
  return function(d) { return "resultaten bijgewerkt"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1727022384 = messageFormatterFn((function(  ) {
  return function(d) { return "fout bij het ophalen van resultaten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1496312860 = messageFormatterFn((function(  ) {
  return function(d) { return "resultaten zijn leeg"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a29889306 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels zoeken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1613920969 = messageFormatterFn((function(  ) {
  return function(d) { return "Sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1300971764 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer in plaats daarvan deze datums"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1878739526 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer datums tonen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1916560642 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder datums tonen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1754280739 = messageFormatterFn((function(  ) {
  return function(d) { return "Particuliere eigenaar"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a673782701 = messageFormatterFn((function(  ) {
  return function(d) { return "Professionele eigenaar"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1052742575 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotelzoekresultaten in " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1426861237 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoekresultaten voor vakantiehuis in " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b9480996 = messageFormatterFn((function(  ) {
  return function(d) { return "Ongeldige hotelzoekresultaten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1179189626 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer weergeven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b517451308 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, we konden geen resultaten vinden.  Probeer je zoekopdracht aan te passen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1639097986 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde filter"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b308829660 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde filters"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1349593828 = messageFormatterFn((function(  ) {
  return function(d) { return "Bestemming ontbreekt"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a766210224 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b37899632 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle filters verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a520794127 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " gasten";}, one: function() { return number(d["0"]) + " gast";}, two: function() { return number(d["0"]) + " gasten";}, few: function() { return number(d["0"]) + " gasten";}, many: function() { return number(d["0"]) + " gasten";}, other: function() { return number(d["0"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b20521177 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is helaas een interne fout opgetreden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1678507540 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer het opnieuw"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1101716084 = messageFormatterFn((function(  ) {
  return function(d) { return "Sla " + d["0"] + " op in jouw lijsten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a886340738 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwijder " + d["0"] + " uit jouw lijsten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1633599734 = messageFormatterFn((function(  ) {
  return function(d) { return "Details van je volgende verblijf"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1602050433 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoek in dit gebied"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a870045841 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er ging iets mis. Voer de zoekopdracht nogmaals uit."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1639072618 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaart sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1172409690 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaart uitvouwen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a578322373 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaart met zoekresultaten uitvouwen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b969747673 = messageFormatterFn((function(  ) {
  return function(d) { return "Lijst tonen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1563834990 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaart met zoekresultaten samenvouwen om lijst te tonen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1592571494 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodatiecontent wordt geladen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a498637346 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " accommodaties";}, one: function() { return number(d["0"]) + " accommodatie";}, two: function() { return number(d["0"]) + " accommodaties";}, few: function() { return number(d["0"]) + " accommodaties";}, many: function() { return number(d["0"]) + " accommodaties";}, other: function() { return number(d["0"]) + " accommodaties";} }) + "\nvanaf " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1551635371 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " accommodaties";}, one: function() { return number(d["0"]) + " accommodatie";}, two: function() { return number(d["0"]) + " accommodaties";}, few: function() { return number(d["0"]) + " accommodaties";}, many: function() { return number(d["0"]) + " accommodaties";}, other: function() { return number(d["0"]) + " accommodaties";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b476393358 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer bekijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b319268667 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder bekijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a873546861 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er deed zich een interne fout voor"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1456321977 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgend item"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1147668157 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorig item"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2878368 = messageFormatterFn((function(  ) {
  return function(d) { return "Afrekenen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1132510207 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Je reis (" + plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " kamers";}, one: function() { return number(d["0"]) + " kamer";}, two: function() { return number(d["0"]) + " kamers";}, few: function() { return number(d["0"]) + " kamers";}, many: function() { return number(d["0"]) + " kamers";}, other: function() { return number(d["0"]) + " kamers";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1593366346 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Je reis (" + plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " accommodaties";}, one: function() { return number(d["0"]) + " accommodatie";}, two: function() { return number(d["0"]) + " accommodaties";}, few: function() { return number(d["0"]) + " accommodaties";}, many: function() { return number(d["0"]) + " accommodaties";}, other: function() { return number(d["0"]) + " accommodaties";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b674940346 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer je volgende kamer"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1484587811 = messageFormatterFn((function(  ) {
  return function(d) { return "Niet meer beschikbaar"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b426076815 = messageFormatterFn((function(  ) {
  return function(d) { return "Een of meer van de accommodaties in je reisplan zijn niet meer beschikbaar. Toch afrekenen?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1025288264 = messageFormatterFn((function(  ) {
  return function(d) { return "per kamer"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2125885792 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " gasten";}, one: function() { return number(d["0"]) + " gast";}, two: function() { return number(d["0"]) + " gasten";}, few: function() { return number(d["0"]) + " gasten";}, many: function() { return number(d["0"]) + " gasten";}, other: function() { return number(d["0"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b567013276 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " kamers";}, one: function() { return number(d["0"]) + " kamer";}, two: function() { return number(d["0"]) + " kamers";}, few: function() { return number(d["0"]) + " kamers";}, many: function() { return number(d["0"]) + " kamers";}, other: function() { return number(d["0"]) + " kamers";} }) + ", " + plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1684484401 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/nacht"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1329005479 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer wijzigen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1970090899 = messageFormatterFn((function(  ) {
  return function(d) { return "Code is naar het klembord gekopieerd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1395750278 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is helaas een interne fout opgetreden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b166153575 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer opnieuw te zoeken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a986244355 = messageFormatterFn((function(  ) {
  return function(d) { return "Opnieuw proberen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1616542224 = messageFormatterFn((function(  ) {
  return function(d) { return "Ophalen en inleveren van huurauto"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2084653031 = messageFormatterFn((function(  ) {
  return function(d) { return "Ophaaltijd"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b286649755 = messageFormatterFn((function(  ) {
  return function(d) { return "Inlevertijd"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1129916548 = messageFormatterFn((function(  ) {
  return function(d) { return "Autoverhuur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b210315663 = messageFormatterFn((function(  ) {
  return function(d) { return "De inlevertijd dient minstens 2 uur na de ophaaltijd te vallen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1618134115 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1618044742 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1617210594 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1617121221 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1616287073 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1616197700 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1615363552 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1615274179 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1614440031 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1614350658 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1613516510 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1613427137 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1612592989 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1612503616 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1611669468 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1611580095 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1610745947 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1610656574 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1609822426 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1609733053 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1589504964 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1589415591 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1588581443 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1588492070 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1587657922 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1587568549 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1586734401 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1586645028 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1585810880 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1585721507 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1584887359 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1584797986 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1583963838 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1583874465 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1583040317 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1582950944 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1582116796 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1582027423 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1581193275 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1581103902 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1560875813 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1560786440 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1559952292 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1559862919 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1559028771 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1558939398 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1558105250 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1558015877 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1482946530 = messageFormatterFn((function(  ) {
  return function(d) { return "Alleen rechtstreekse vluchten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1844352047 = messageFormatterFn((function(  ) {
  return function(d) { return "Voorkeursklasse"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1403626585 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b406099826 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1451705319 = messageFormatterFn((function(  ) {
  return function(d) { return "Business Class"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b360816817 = messageFormatterFn((function(  ) {
  return function(d) { return "First Class"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1586108966 = messageFormatterFn((function(  ) {
  return function(d) { return "Gasten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1071127708 = messageFormatterFn((function(  ) {
  return function(d) { return "Er dient minstens 1 reiziger (6 jaar of ouder) per baby op schoot te zijn."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1880132311 = messageFormatterFn((function(  ) {
  return function(d) { return "Baby’s"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a460094176 = messageFormatterFn((function(  ) {
  return function(d) { return "(2-17 jaar)"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b105031150 = messageFormatterFn((function(  ) {
  return function(d) { return "Jonger dan 2 jaar"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b158491584 = messageFormatterFn((function(  ) {
  return function(d) { return "Leeftijd baby " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b137718756 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal baby's in kamer " + d["0"] + " verlagen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2034022136 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal baby's in kamer " + d["0"] + " verhogen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1985759242 = messageFormatterFn((function(  ) {
  return function(d) { return "Kinderen jonger dan 2 jaar dienen in een stoel of op schoot te zitten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1618868174 = messageFormatterFn((function(  ) {
  return function(d) { return "Op schoot"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a806385456 = messageFormatterFn((function(  ) {
  return function(d) { return "Op stoel"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1178706641 = messageFormatterFn((function(  ) {
  return function(d) { return "Leeftijdsreglement airline"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1849416933 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertrek vanaf"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a555403757 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertrekdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a594306089 = messageFormatterFn((function(  ) {
  return function(d) { return "Retourdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1387022457 = messageFormatterFn((function(  ) {
  return function(d) { return "Kies een vertreklocatie"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1362443071 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik heb slechts voor een deel van de reis accommodaties nodig"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1112450878 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is een interne fout opgetreden. Probeer het opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a792655126 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer nog minstens 1 accommodatie om te vergelijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2090585555 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/" + plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["1"]) + " accommodaties";}, one: function() { return number(d["1"]) + " accommodatie";}, two: function() { return number(d["1"]) + " accommodaties";}, few: function() { return number(d["1"]) + " accommodaties";}, many: function() { return number(d["1"]) + " accommodaties";}, other: function() { return number(d["1"]) + " accommodaties";} }) + " geselecteerd"; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a513661967 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "van " + plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["1"]) + " accommodaties";}, one: function() { return number(d["1"]) + " accommodatie";}, two: function() { return number(d["1"]) + " accommodaties";}, few: function() { return number(d["1"]) + " accommodaties";}, many: function() { return number(d["1"]) + " accommodaties";}, other: function() { return number(d["1"]) + " accommodaties";} }) + " geselecteerd om te vergelijken"; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a383776413 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergelijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1258594913 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde accommodaties vergelijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2125455353 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergelijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a213052867 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde accommodaties vergelijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a918083701 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a522052295 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik om de accommodatie te bekijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a102975828 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b45996728 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik om de accommodatie uit de vergelijking te verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1314229314 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodaties vergelijken sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2063560728 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodaties vergelijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a839513345 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergelijk tot 5 accommodaties om je te helpen beslissen. Selecteer 'Vergelijken' om te beginnen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a254935203 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergelijk tot 5 accommodaties om je te helpen beslissen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1708939877 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer het nu"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1437353919 = messageFormatterFn((function(  ) {
  return function(d) { return "Beginnen met vergelijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b962223187 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergelijken uitschakelen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a235677559 = messageFormatterFn((function(  ) {
  return function(d) { return "Misschien later"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1638931700 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodaties vergelijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b202381209 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer 'Vergelijken' in de zoekresultaten om te beginnen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1979024899 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekijk tot 5 accommodaties naast elkaar."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1059200986 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is niet beschikbaar."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b729934973 = messageFormatterFn((function(  ) {
  return function(d) { return "Niet beschikbaar voor uitchecken op " + d["0"] + "."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1736490190 = messageFormatterFn((function(  ) {
  return function(d) { return "Niet beschikbaar voor inchecken op " + d["0"] + "."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1716647708 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b197751872 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle accommodatievoorzieningen bekijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a736813619 = messageFormatterFn((function(  ) {
  return function(d) { return "Gastenbeoordelingen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a303477384 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoogtepunten van de omgeving"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1470479119 = messageFormatterFn((function(  ) {
  return function(d) { return "Pas je verblijf aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a703305873 = messageFormatterFn((function(  ) {
  return function(d) { return "De Pas je verblijf aan-sectie sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b282194952 = messageFormatterFn((function(  ) {
  return function(d) { return "Stuur de eigenaar een bericht"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1555932415 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is bij ons iets fout gegaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1299675118 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer je verzoek opnieuw te verzenden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a984283088 = messageFormatterFn((function(  ) {
  return function(d) { return "Opnieuw proberen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1457759965 = messageFormatterFn((function(  ) {
  return function(d) { return "Advertentie"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b540079989 = messageFormatterFn((function(  ) {
  return function(d) { return "Opnieuw proberen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1960422780 = messageFormatterFn((function(  ) {
  return function(d) { return "Over deze advertentie"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b329401858 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is iets misgegaan bij het ophalen van deze informatie."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1726598896 = messageFormatterFn((function(  ) {
  return function(d) { return "We kunnen de informatie op dit moment niet weergeven."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b742711832 = messageFormatterFn((function(  ) {
  return function(d) { return "Raster"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a70276363 = messageFormatterFn((function(  ) {
  return function(d) { return "Rasterweergave"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b607564480 = messageFormatterFn((function(  ) {
  return function(d) { return "Lijst"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a205423715 = messageFormatterFn((function(  ) {
  return function(d) { return "Lijstweergave"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b555615087 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", geselecteerd"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2078548630 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", niet geselecteerd"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1576881136 = messageFormatterFn((function(  ) {
  return function(d) { return "Het totaal is inclusief alle belastingen en toeslagen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a547498449 = messageFormatterFn((function(  ) {
  return function(d) { return "Geen onaangename verrassingen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a420299165 = messageFormatterFn((function(  ) {
  return function(d) { return "Vrbo-prijzen zijn inclusief alle toeslagen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1531631614 = messageFormatterFn((function(  ) {
  return function(d) { return "De prijs die je ziet, is ook de prijs die je betaalt."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1658060367 = messageFormatterFn((function(  ) {
  return function(d) { return "Wat je ziet, is wat je betaalt"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a832390576 = messageFormatterFn((function(  ) {
  return function(d) { return "Niet alle reiswebsites laten je op voorhand de totale prijs zien. Wij wel. Wat je ziet is wat je betaalt."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a179450526 = messageFormatterFn((function(  ) {
  return function(d) { return "Belastingen worden toegevoegd bij het afrekenen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a660122156 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoek je op verschillende sites?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a138814867 = messageFormatterFn((function(  ) {
  return function(d) { return "Onze getoonde totale prijs is inclusief belastingen en toeslagen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a455655616 = messageFormatterFn((function(  ) {
  return function(d) { return "Blijven rondkijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b765605368 = messageFormatterFn((function(  ) {
  return function(d) { return "Boek met Vertrouwen-garantie"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b201242306 = messageFormatterFn((function(  ) {
  return function(d) { return "Soms wandelt niet alles volgens plan, maar we zijn er om je te helpen als er een probleem is met je verblijf."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a718203699 = messageFormatterFn((function(  ) {
  return function(d) { return "24/7 live ondersteuning voor alles wat je nodig hebt vóór, tijdens en na je verblijf"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1354414873 = messageFormatterFn((function(  ) {
  return function(d) { return "Betalingsbescherming en fraudepreventie voor borgsommen en toeslagen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2064931130 = messageFormatterFn((function(  ) {
  return function(d) { return "Toegewijde hulp om een nieuwe accommodatie voor je te vinden als je boeking niet doorgaat"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1352347885 = messageFormatterFn((function(  ) {
  return function(d) { return "Noodhulp bij boekingen als je bij aankomst geen toegang hebt tot de accommodatie"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b66243011 = messageFormatterFn((function(  ) {
  return function(d) { return "Openingsuren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a475645169 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoekresultaten voor huurauto's in " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2101663187 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We hebben " + plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " nachten";}, one: function() { return number(d["0"]) + " nacht";}, two: function() { return number(d["0"]) + " nachten";}, few: function() { return number(d["0"]) + " nachten";}, many: function() { return number(d["0"]) + " nachten";}, other: function() { return number(d["0"]) + " nachten";} }) + " aan je verblijf toegevoegd."; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a592755374 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Voeg " + plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " nachten";}, one: function() { return number(d["0"]) + " nacht";}, two: function() { return number(d["0"]) + " nachten";}, few: function() { return number(d["0"]) + " nachten";}, many: function() { return number(d["0"]) + " nachten";}, other: function() { return number(d["0"]) + " nachten";} }) + " toe en bespaar"; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1532662830 = messageFormatterFn((function(  ) {
  return function(d) { return "Deze eigenaar biedt een maandelijkse korting als je meer dan 28 nachten verblijft."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2014721806 = messageFormatterFn((function(  ) {
  return function(d) { return "Deze eigenaar biedt een wekelijkse korting als je meer dan 7 nachten verblijft."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a447922784 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " nachten";}, one: function() { return number(d["0"]) + " nacht";}, two: function() { return number(d["0"]) + " nachten";}, few: function() { return number(d["0"]) + " nachten";}, many: function() { return number(d["0"]) + " nachten";}, other: function() { return number(d["0"]) + " nachten";} }) + " toevoegen"; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a132851607 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1648300019 = messageFormatterFn((function(  ) {
  return function(d) { return "00.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b963035174 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a552413238 = messageFormatterFn((function(  ) {
  return function(d) { return "00.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b286435861 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1229012551 = messageFormatterFn((function(  ) {
  return function(d) { return "01.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1382322642 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a133125770 = messageFormatterFn((function(  ) {
  return function(d) { return "01.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b157353142 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1358095270 = messageFormatterFn((function(  ) {
  return function(d) { return "02.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1253239923 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a262208489 = messageFormatterFn((function(  ) {
  return function(d) { return "02.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b28270423 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1487177989 = messageFormatterFn((function(  ) {
  return function(d) { return "03.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1124157204 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a391291208 = messageFormatterFn((function(  ) {
  return function(d) { return "03.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a100812296 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1616260708 = messageFormatterFn((function(  ) {
  return function(d) { return "04.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b995074485 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a520373927 = messageFormatterFn((function(  ) {
  return function(d) { return "04.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a229895015 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1745343427 = messageFormatterFn((function(  ) {
  return function(d) { return "05.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b865991766 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a649456646 = messageFormatterFn((function(  ) {
  return function(d) { return "05.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a358977734 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1874426146 = messageFormatterFn((function(  ) {
  return function(d) { return "06.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b736909047 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a778539365 = messageFormatterFn((function(  ) {
  return function(d) { return "06.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a488060453 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2003508865 = messageFormatterFn((function(  ) {
  return function(d) { return "07.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b607826328 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a907622084 = messageFormatterFn((function(  ) {
  return function(d) { return "07.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a617143172 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2132591584 = messageFormatterFn((function(  ) {
  return function(d) { return "08.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b478743609 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1036704803 = messageFormatterFn((function(  ) {
  return function(d) { return "08.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a746225891 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2033292993 = messageFormatterFn((function(  ) {
  return function(d) { return "09.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b349660890 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1165787522 = messageFormatterFn((function(  ) {
  return function(d) { return "09.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b125313831 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1390134581 = messageFormatterFn((function(  ) {
  return function(d) { return "10.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1221200612 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a294247800 = messageFormatterFn((function(  ) {
  return function(d) { return "10.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a3768888 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1519217300 = messageFormatterFn((function(  ) {
  return function(d) { return "11.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1092117893 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a423330519 = messageFormatterFn((function(  ) {
  return function(d) { return "11.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1209161562 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a306286850 = messageFormatterFn((function(  ) {
  return function(d) { return "12.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1989918953 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b789599931 = messageFormatterFn((function(  ) {
  return function(d) { return "12.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1628449030 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b113000618 = messageFormatterFn((function(  ) {
  return function(d) { return "13.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1570631485 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1208887399 = messageFormatterFn((function(  ) {
  return function(d) { return "13.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1499366311 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a16082101 = messageFormatterFn((function(  ) {
  return function(d) { return "14.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1699714204 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1079804680 = messageFormatterFn((function(  ) {
  return function(d) { return "14.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1370283592 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a145164820 = messageFormatterFn((function(  ) {
  return function(d) { return "15.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1828796923 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b950721961 = messageFormatterFn((function(  ) {
  return function(d) { return "15.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1241200873 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a274247539 = messageFormatterFn((function(  ) {
  return function(d) { return "16.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1957879642 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b821639242 = messageFormatterFn((function(  ) {
  return function(d) { return "16.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1112118154 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a403330258 = messageFormatterFn((function(  ) {
  return function(d) { return "17.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2086962361 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b692556523 = messageFormatterFn((function(  ) {
  return function(d) { return "17.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b983035435 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a532412977 = messageFormatterFn((function(  ) {
  return function(d) { return "18.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2078922216 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b563473804 = messageFormatterFn((function(  ) {
  return function(d) { return "18.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b853952716 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a661495696 = messageFormatterFn((function(  ) {
  return function(d) { return "19.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1949839497 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b434391085 = messageFormatterFn((function(  ) {
  return function(d) { return "19.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b724869997 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a790578415 = messageFormatterFn((function(  ) {
  return function(d) { return "20.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1820756778 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b305308366 = messageFormatterFn((function(  ) {
  return function(d) { return "20.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b595787278 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a919661134 = messageFormatterFn((function(  ) {
  return function(d) { return "21.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1691674059 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b176225647 = messageFormatterFn((function(  ) {
  return function(d) { return "21.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1467327000 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a48121412 = messageFormatterFn((function(  ) {
  return function(d) { return "22.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1731753515 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1047765369 = messageFormatterFn((function(  ) {
  return function(d) { return "22.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1338244281 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a177204131 = messageFormatterFn((function(  ) {
  return function(d) { return "23.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1860836234 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b918682650 = messageFormatterFn((function(  ) {
  return function(d) { return "23.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1865867724 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a845626408 = messageFormatterFn((function(  ) {
  return function(d) { return "00.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2093555855 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1073314539 = messageFormatterFn((function(  ) {
  return function(d) { return "00.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1844328928 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1430397052 = messageFormatterFn((function(  ) {
  return function(d) { return "01.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1616640797 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1658085183 = messageFormatterFn((function(  ) {
  return function(d) { return "01.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1940104191 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a919862875 = messageFormatterFn((function(  ) {
  return function(d) { return "02.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2127174974 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1147551006 = messageFormatterFn((function(  ) {
  return function(d) { return "02.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1429570014 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a409328698 = messageFormatterFn((function(  ) {
  return function(d) { return "03.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1657258145 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a637016829 = messageFormatterFn((function(  ) {
  return function(d) { return "03.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a919035837 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b101205479 = messageFormatterFn((function(  ) {
  return function(d) { return "04.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1146723968 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a126482652 = messageFormatterFn((function(  ) {
  return function(d) { return "04.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a408501660 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b611739656 = messageFormatterFn((function(  ) {
  return function(d) { return "05.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a636189791 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b384051525 = messageFormatterFn((function(  ) {
  return function(d) { return "05.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b102032517 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1122273833 = messageFormatterFn((function(  ) {
  return function(d) { return "06.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a125655614 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b894585702 = messageFormatterFn((function(  ) {
  return function(d) { return "06.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b612566694 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1632808010 = messageFormatterFn((function(  ) {
  return function(d) { return "07.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b384878563 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1405119879 = messageFormatterFn((function(  ) {
  return function(d) { return "07.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1123100871 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2143342187 = messageFormatterFn((function(  ) {
  return function(d) { return "08.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b895412740 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1915654056 = messageFormatterFn((function(  ) {
  return function(d) { return "08.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1633635048 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1641090932 = messageFormatterFn((function(  ) {
  return function(d) { return "09.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1405946917 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1868779063 = messageFormatterFn((function(  ) {
  return function(d) { return "09.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1408031218 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1866694762 = messageFormatterFn((function(  ) {
  return function(d) { return "10.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1180343087 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2094382893 = messageFormatterFn((function(  ) {
  return function(d) { return "10.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1918565395 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1356160585 = messageFormatterFn((function(  ) {
  return function(d) { return "11.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1690877264 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1583848716 = messageFormatterFn((function(  ) {
  return function(d) { return "11.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1759789915 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a739548599 = messageFormatterFn((function(  ) {
  return function(d) { return "12.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1987478046 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a967236730 = messageFormatterFn((function(  ) {
  return function(d) { return "12.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1950406737 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1324319243 = messageFormatterFn((function(  ) {
  return function(d) { return "13.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1722718606 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1552007374 = messageFormatterFn((function(  ) {
  return function(d) { return "13.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1834026382 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a813785066 = messageFormatterFn((function(  ) {
  return function(d) { return "14.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2061714513 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1041473197 = messageFormatterFn((function(  ) {
  return function(d) { return "14.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1323492205 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a303250889 = messageFormatterFn((function(  ) {
  return function(d) { return "15.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1551180336 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a530939020 = messageFormatterFn((function(  ) {
  return function(d) { return "15.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a812958028 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b207283288 = messageFormatterFn((function(  ) {
  return function(d) { return "16.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1040646159 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a20404843 = messageFormatterFn((function(  ) {
  return function(d) { return "16.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a302423851 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b717817465 = messageFormatterFn((function(  ) {
  return function(d) { return "17.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a530111982 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b490129334 = messageFormatterFn((function(  ) {
  return function(d) { return "17.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b208110326 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1228351642 = messageFormatterFn((function(  ) {
  return function(d) { return "18.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a19577805 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1000663511 = messageFormatterFn((function(  ) {
  return function(d) { return "18.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b718644503 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1738885819 = messageFormatterFn((function(  ) {
  return function(d) { return "19.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b490956372 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1511197688 = messageFormatterFn((function(  ) {
  return function(d) { return "19.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1229178680 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2045547300 = messageFormatterFn((function(  ) {
  return function(d) { return "20.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1001490549 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2021731865 = messageFormatterFn((function(  ) {
  return function(d) { return "20.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1739712857 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1535013123 = messageFormatterFn((function(  ) {
  return function(d) { return "21.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1512024726 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1762701254 = messageFormatterFn((function(  ) {
  return function(d) { return "21.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1514109027 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1760616953 = messageFormatterFn((function(  ) {
  return function(d) { return "22.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1286420896 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1988305084 = messageFormatterFn((function(  ) {
  return function(d) { return "22.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2024643204 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1250082776 = messageFormatterFn((function(  ) {
  return function(d) { return "23.15 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1796955073 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1477770907 = messageFormatterFn((function(  ) {
  return function(d) { return "23.45 uur"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a816184381 = messageFormatterFn((function(  ) {
  return function(d) { return "Sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1684029973 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b982373937 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1466337677 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2073678475 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1602254924 = messageFormatterFn((function(  ) {
  return function(d) { return "geselecteerd"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a256799745 = messageFormatterFn((function(  ) {
  return function(d) { return "Laden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a806425426 = messageFormatterFn((function(  ) {
  return function(d) { return "Wissen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1139064492 = messageFormatterFn((function(  ) {
  return function(d) { return "Opent in een nieuw venster"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b126090330 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer weergeven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1180166899 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder weergeven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a258073041 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer weergeven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a993978974 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder weergeven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b120110899 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geselecteerd. Kies nu een uitcheckdatum."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b555621148 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geselecteerd. Kies Gereed om deze datums op te slaan en de kalender te sluiten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1369041160 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", huidige incheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a232629401 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", huidige uitcheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a846634479 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", datum uitgeschakeld"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a246751916 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", huidige maand"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1437657671 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " en " + d["1"] + " worden nu getoond"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1965787197 = messageFormatterFn((function(  ) {
  return function(d) { return "kalender geopend. Selecteer een datum uit de onderstaande tabellen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1220892431 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren, sluit de kalender zonder je wijzigingen op te slaan. Of selecteer een datum uit de onderstaande tabellen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a818812543 = messageFormatterFn((function(  ) {
  return function(d) { return "Wis de geselecteerde datums."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1059898988 = messageFormatterFn((function(  ) {
  return function(d) { return "Sla de wijzigingen op en sluit de kalender."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1209337093 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " nachten";}, one: function() { return number(d["0"]) + " nacht";}, two: function() { return number(d["0"]) + " nachten";}, few: function() { return number(d["0"]) + " nachten";}, many: function() { return number(d["0"]) + " nachten";}, other: function() { return number(d["0"]) + " nachten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a514171285 = messageFormatterFn((function(  ) {
  return function(d) { return "Inchecken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1590910438 = messageFormatterFn((function(  ) {
  return function(d) { return "Uitchecken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1098595865 = messageFormatterFn((function(  ) {
  return function(d) { return "Datums wissen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1242130438 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1933382356 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoeken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1189639838 = messageFormatterFn((function(  ) {
  return function(d) { return "Bewerk de incheckdatum in de onderstaande tabellen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1141670835 = messageFormatterFn((function(  ) {
  return function(d) { return "Bewerk de uitcheckdatum in de onderstaande tabellen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1748378530 = messageFormatterFn((function(  ) {
  return function(d) { return "geselecteerd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2100774897 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geselecteerd. Sluit de kalender of ga verder met het wijzigen van de geselecteerde datum."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a77755991 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " tot " + d["1"] + " geselecteerd. Sluit de kalender of ga verder met het wijzigen van de geselecteerde datums."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1643442211 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geselecteerd. " + d["1"] + ". Sluit de kalender of ga verder met het wijzigen van de geselecteerde datum."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1487803045 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " tot " + d["1"] + " geselecteerd. " + d["2"] + ". Sluit de kalender of ga verder met het wijzigen van de geselecteerde datums."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2067053918 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer incheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1669365595 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer uitcheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1306874890 = messageFormatterFn((function(  ) {
  return function(d) { return "leeg"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a706613224 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorige maand"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1648321100 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgende maand"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b174526141 = messageFormatterFn((function(  ) {
  return function(d) { return "Ga direct naar de knop " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1352627365 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " tot en met " + d["1"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b755390 = messageFormatterFn((function(  ) {
  return function(d) { return "Datums zijn gewist"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1804481515 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "er " + plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return "zijn " + number(d["0"]) + " resultaten";}, one: function() { return "is " + number(d["0"]) + " resultaat";}, two: function() { return "zijn " + number(d["0"]) + " resultaten";}, few: function() { return "zijn " + number(d["0"]) + " resultaten";}, many: function() { return "zijn " + number(d["0"]) + " resultaten";}, other: function() { return "zijn " + number(d["0"]) + " resultaten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b534731156 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "er " + plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return "zijn " + number(d["1"]) + " resultaten";}, one: function() { return "is " + number(d["1"]) + " resultaat";}, two: function() { return "zijn " + number(d["1"]) + " resultaten";}, few: function() { return "zijn " + number(d["1"]) + " resultaten";}, many: function() { return "zijn " + number(d["1"]) + " resultaten";}, other: function() { return "zijn " + number(d["1"]) + " resultaten";} }) + " beschikbaar voor " + d["0"] + ". Gebruik de pijltjestoetsen of swipe om door de lijst te gaan."; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2139413912 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoekopdracht voor " + d["0"] + " geopend, voer zoekterm in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a865998343 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt " + d["0"] + " geselecteerd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1258478372 = messageFormatterFn((function(  ) {
  return function(d) { return "Het menu is gesloten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1462603626 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Zoekopdracht voor " + d["0"] + " geopend. " + plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";}, one: function() { return "Er wordt momenteel " + number(d["1"]) + " suggestie";}, two: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";}, few: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";}, many: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";}, other: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";} }) + " voor " + d["2"] + " weergegeven. Navigeer naar de onderstaande lijst."; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a663062669 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Zoekopdracht voor " + d["0"] + " geopend. " + plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return "Er worden " + number(d["1"]) + " suggesties";}, one: function() { return "Er wordt " + number(d["1"]) + " suggestie";}, two: function() { return "Er worden " + number(d["1"]) + " suggesties";}, few: function() { return "Er worden " + number(d["1"]) + " suggesties";}, many: function() { return "Er worden " + number(d["1"]) + " suggesties";}, other: function() { return "Er worden " + number(d["1"]) + " suggesties";} }) + " weergegeven. Voer een zoekterm in of navigeer naar de onderstaande lijst."; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1502204887 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Zoekopdracht voor " + d["0"] + " geopend. Momenteel " + d["1"] + " geselecteerd. " + plural(d["2"], 0, pluralFuncs["nl-BE"], { zero: function() { return "Er worden " + number(d["2"]) + " suggesties";}, one: function() { return "Er wordt " + number(d["2"]) + " suggestie";}, two: function() { return "Er worden " + number(d["2"]) + " suggesties";}, few: function() { return "Er worden " + number(d["2"]) + " suggesties";}, many: function() { return "Er worden " + number(d["2"]) + " suggesties";}, other: function() { return "Er worden " + number(d["2"]) + " suggesties";} }) + " voor " + d["3"] + " weergegeven. Navigeer naar de onderstaande lijst."; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1507474223 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1898930746 = messageFormatterFn((function(  ) {
  return function(d) { return "Alles wissen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a253252857 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde items"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1736384698 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " verwijderd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1566727405 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle selecties verwijderd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b93205378 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt info toegevoegd aan het invoerveld. Zoek of kies uit de onderstaande categorieën."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b209116193 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoeken naar ‘" + d["0"] + "’"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a503234782 = messageFormatterFn((function(  ) {
  return function(d) { return "Geen resultaten voor “" + d["0"] + "”"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2100635468 = messageFormatterFn((function(  ) {
  return function(d) { return "Luchthaven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1705747747 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b414510733 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezienswaardigheid"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a228329412 = messageFormatterFn((function(  ) {
  return function(d) { return "In de buurt"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b707287207 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer ‘" + d["0"] + "’"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a695061932 = messageFormatterFn((function(  ) {
  return function(d) { return "Regio's / plaatsen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2088196544 = messageFormatterFn((function(  ) {
  return function(d) { return "Luchthavens"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1847494696 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezienswaardigheden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a385882985 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1704411351 = messageFormatterFn((function(  ) {
  return function(d) { return "Adres"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b42305523 = messageFormatterFn((function(  ) {
  return function(d) { return "Treinstation"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1984274460 = messageFormatterFn((function(  ) {
  return function(d) { return "Metrostations"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a127131712 = messageFormatterFn((function(  ) {
  return function(d) { return "Locaties in de buurt"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b853450807 = messageFormatterFn((function(  ) {
  return function(d) { return "Recente zoekopdrachten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b374778961 = messageFormatterFn((function(  ) {
  return function(d) { return "Reizigers zochten ook naar"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2115645466 = messageFormatterFn((function(  ) {
  return function(d) { return "Ontdek populaire bestemmingen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1096544462 = messageFormatterFn((function(  ) {
  return function(d) { return "Populaire bestemmingen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1473358994 = messageFormatterFn((function(  ) {
  return function(d) { return "Veel gezochte bestemmingen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1455688336 = messageFormatterFn((function(  ) {
  return function(d) { return "Je locatie"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a411841581 = messageFormatterFn((function(  ) {
  return function(d) { return "Locatie delen is uitgeschakeld"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b790757117 = messageFormatterFn((function(  ) {
  return function(d) { return "We kunnen je locatie niet bepalen. Schakel de locatievoorzieningen van je apparaat in zodat we je locatie kunnen bepalen of voer een bestemming in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b958372735 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " kamers";}, one: function() { return number(d["0"]) + " kamer";}, two: function() { return number(d["0"]) + " kamers";}, few: function() { return number(d["0"]) + " kamers";}, many: function() { return number(d["0"]) + " kamers";}, other: function() { return number(d["0"]) + " kamers";} }) + ", " + plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.b112356043 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " reizigers";}, one: function() { return number(d["0"]) + " reiziger";}, other: function() { return number(d["0"]) + " reizigers";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1926340751 = messageFormatterFn((function(  ) {
  return function(d) { return "De waarde van het veld " + d["0"] + " is nu " + d["1"] + ". De waarde van het veld " + d["2"] + " is nu " + d["3"] + "."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a897198526 = messageFormatterFn((function(  ) {
  return function(d) { return "Wissel de velden " + d["0"] + " en " + d["1"] + " om."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b30852939 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord weergeven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b345195078 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord verbergen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1128992627 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " wordt nu getoond"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b920549310 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " van " + d["1"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1044174004 = messageFormatterFn((function(  ) {
  return function(d) { return "Afbeelding " + d["0"] + " van " + d["1"] + ". " + d["2"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a575912497 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgende afbeelding openen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a948094637 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorige afbeelding openen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1266228659 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle " + d["0"] + " afbeeldingen openen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a111289800 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Toon " + plural(d["0"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["0"]) + " afbeeldingen";}, one: function() { return number(d["0"]) + " afbeelding";}, two: function() { return number(d["0"]) + " afbeeldingen";}, few: function() { return number(d["0"]) + " afbeeldingen";}, many: function() { return number(d["0"]) + " afbeeldingen";}, other: function() { return number(d["0"]) + " afbeeldingen";} }) + " voor " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a946160773 = messageFormatterFn((function(  ) {
  return function(d) { return "Voltooid:"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a112921587 = messageFormatterFn((function(  ) {
  return function(d) { return "Huidig:"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b901942815 = messageFormatterFn((function(  ) {
  return function(d) { return "Stap " + d["0"] + " van " + d["1"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b337883941 = messageFormatterFn((function(  ) {
  return function(d) { return "Stap " + d["0"] + " van " + d["1"] + ":"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b848617572 = messageFormatterFn((function(  ) {
  return function(d) { return "Afbeelding " + d["0"] + " van " + d["1"] + ". " + d["2"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2031640807 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgende afbeelding"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1253443691 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorige afbeelding"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b257594119 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", vergroten naar volledig scherm"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1421645317 = messageFormatterFn((function(  ) {
  return function(d) { return "Item " + d["0"] + ", vergroten naar volledig scherm"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1845796145 = messageFormatterFn((function(  ) {
  return function(d) { return "Huidige pagina"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2045003071 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer broodkruimels weergeven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2082824187 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder broodkruimels weergeven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b947072856 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " procent, bezig met laden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1857931741 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezig met laden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1696697261 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b263389308 = messageFormatterFn((function(  ) {
  return function(d) { return "Er ging iets mis."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a8978280 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer deze video op www.youtube.com te bekijken of schakel Javascript in je browser in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a363379152 = messageFormatterFn((function(  ) {
  return function(d) { return "Video afspelen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1924034208 = messageFormatterFn((function(  ) {
  return function(d) { return "Video pauzeren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a249942264 = messageFormatterFn((function(  ) {
  return function(d) { return "Video wordt geladen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1579998418 = messageFormatterFn((function(  ) {
  return function(d) { return "Photosphere"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1224794440 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit is een 360-graden-foto. Gebruik de Ctrl- en pijltoetsen of Cmd- en pijltoetsen om te bewegen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1468505147 = messageFormatterFn((function(  ) {
  return function(d) { return "Huidige weergave: " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1973749670 = messageFormatterFn((function(  ) {
  return function(d) { return "Naar links bewegen. Positie: " + d["0"] + " graden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a88516863 = messageFormatterFn((function(  ) {
  return function(d) { return "Naar rechts bewegen. Positie: " + d["0"] + " graden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a905484270 = messageFormatterFn((function(  ) {
  return function(d) { return "Omhoog bewegen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2101920309 = messageFormatterFn((function(  ) {
  return function(d) { return "Omlaag bewegen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1312644070 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt de bovenkant bereikt"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b417186788 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt de onderkant bereikt"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a639672304 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle rijen selecteren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1489873551 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle rijen deselecteren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1260803615 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolom ordenen van hoog naar laag"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a534291239 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolom ordenen van laag naar hoog"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b367212233 = messageFormatterFn((function(  ) {
  return function(d) { return "De kolom is nu geordend van hoog naar laag"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1921267345 = messageFormatterFn((function(  ) {
  return function(d) { return "De kolom is nu geordend van laag naar hoog"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1376578665 = messageFormatterFn((function(  ) {
  return function(d) { return "Rij " + d["0"] + " uitvouwen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1582191434 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " van " + plural(d["1"], 0, pluralFuncs["nl-BE"], { zero: function() { return number(d["1"]) + " items";}, one: function() { return number(d["1"]) + " item";}, two: function() { return number(d["1"]) + " items";}, few: function() { return number(d["1"]) + " items";}, many: function() { return number(d["1"]) + " items";}, other: function() { return number(d["1"]) + " items";} }) + " weergegeven"; }
})(messageFormat.number, messageFormat.plural, {"nl-BE": Globalize("nl-BE").pluralGenerator()}), Globalize("nl-BE").pluralGenerator({}));
Globalize.a617254810 = messageFormatterFn((function(  ) {
  return function(d) { return "De weergegeven maanden zijn " + d["0"] + " " + d["1"] + " en " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a973953266 = messageFormatterFn((function(  ) {
  return function(d) { return "De weergegeven maand is " + d["0"] + " " + d["1"] + "."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1957191331 = messageFormatterFn((function(  ) {
  return function(d) { return "De weergegeven maanden zijn " + d["0"] + " " + d["1"] + " tot " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1270933054 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckdatum gewist."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1152438187 = messageFormatterFn((function(  ) {
  return function(d) { return "Uitcheckdatum gewist."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1713640726 = messageFormatterFn((function(  ) {
  return function(d) { return "Datums gewist."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1871619579 = messageFormatterFn((function(  ) {
  return function(d) { return "Datums wissen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1530259739 = messageFormatterFn((function(  ) {
  return function(d) { return "Bevestigen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a572553992 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgende maand"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1027752520 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorige maand"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b406243474 = messageFormatterFn((function(  ) {
  return function(d) { return "Ga direct naar de verzendknop"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2016642527 = messageFormatterFn((function(  ) {
  return function(d) { return "Ga direct naar de knop " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b946746322 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgende maand"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2057997550 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorige maand"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a664601527 = messageFormatterFn((function(  ) {
  return function(d) { return "Je selecteerde " + d["0"] + " als incheckdatum."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a42975108 = messageFormatterFn((function(  ) {
  return function(d) { return "Je selecteerde " + d["0"] + " als uitcheckdatum."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1155264813 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is geen geldige incheckdatum."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1032473134 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is geen geldige uitcheckdatum."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2105431777 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is niet beschikbaar."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2051349264 = messageFormatterFn((function(  ) {
  return function(d) { return "Vandaag"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1337414098 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde incheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1287555765 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde uitcheckdatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1437798966 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde datum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1298984102 = messageFormatterFn((function(  ) {
  return function(d) { return "Begindatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a214760671 = messageFormatterFn((function(  ) {
  return function(d) { return "Einddatum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1561162816 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren, sluit de kalender zonder je wijzigingen op te slaan. Of selecteer een datum uit de onderstaande tabellen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1505285105 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " op " + d["1"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a737195654 = messageFormatterFn((function(  ) {
  return function(d) { return "Druk op de Escape-toets om de lijst te sluiten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b673971729 = messageFormatterFn((function(  ) {
  return function(d) { return "Druk op de Escape-toets om de lijst samen te vouwen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2146960830 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een getal in dat kleinder is dan " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1581667651 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een getal in dat groter is dan " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1569392560 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een getal in tussen " + d["0"] + " en " + d["1"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1728710463 = messageFormatterFn((function(  ) {
  return function(d) { return "Vereist"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a408458917 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan bij " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a517174494 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom terug! Meld je aan via"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b648875716 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom terug! Meld je aan en bespaar ten minste 10% extra op duizenden accommodaties met ledenprijzen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b339720578 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadres"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1642149489 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1877292340 = messageFormatterFn((function(  ) {
  return function(d) { return "Een account nodig?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1216926170 = messageFormatterFn((function(  ) {
  return function(d) { return "We melden je aan..."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b668725053 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden via Facebook"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1105042422 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden via Google"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b687835206 = messageFormatterFn((function(  ) {
  return function(d) { return "Houd me aangemeld"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1755861545 = messageFormatterFn((function(  ) {
  return function(d) { return "Houd me aangemeld (gebruikt cookies)"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a644079519 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a644438933 = messageFormatterFn((function(  ) {
  return function(d) { return "Registreren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1266491407 = messageFormatterFn((function(  ) {
  return function(d) { return "Of <a href=\"" + d["0"] + "\">meld je aan via Facebook</a>"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1288091205 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord vergeten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1143747150 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je e-mailadres in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1992797852 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een geldig e-mailadres in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1426426815 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je wachtwoord in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1553267077 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer het opnieuw"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2033034121 = messageFormatterFn((function(  ) {
  return function(d) { return "Oeps, er is iets fout gelopen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1278029337 = messageFormatterFn((function(  ) {
  return function(d) { return "Corrigeer de onderstaande fout om door te gaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a891354686 = messageFormatterFn((function(  ) {
  return function(d) { return "Corrigeer de twee onderstaande fouten om door te gaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1012542388 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan met je e-mailadres"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a533586055 = messageFormatterFn((function(  ) {
  return function(d) { return "Of meld je aan met je e-mailadres"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1775589118 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadres"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1556084929 = messageFormatterFn((function(  ) {
  return function(d) { return "of"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1792418771 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord vergeten?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b279871696 = messageFormatterFn((function(  ) {
  return function(d) { return "Geen lid?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a476258554 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a776971413 = messageFormatterFn((function(  ) {
  return function(d) { return "Door me aan te melden, ga ik akkoord met de <a href=\"" + d["0"] + "\" target=\"_blank\">Voorwaarden & Bepalingen van " + d["1"] + ". <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a954335583 = messageFormatterFn((function(  ) {
  return function(d) { return "Door me aan te melden bij mijn " + d["0"] + "-account ga ik akkoord met de <a href=\"" + d["1"] + "\" target=\"_blank\">Gebruiksvoorwaarden van " + d["2"] + "<span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>, het <a href=\"" + d["3"] + "\" target=\"_blank\">Privacybeleid<span class=\"is-visually-hidden\">opent in een nieuw venster</span></a> en de <a href=\"" + d["4"] + "\" target=\"_blank\">Voorwaarden & Bepalingen van " + d["5"] + "<span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>. "; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2075736539 = messageFormatterFn((function(  ) {
  return function(d) { return "Registreer je bij <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + ". <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a> Door me te registreren ga ik akkoord met alle <a href=\"" + d["3"] + "\" target=\"_blank\">Voorwaarden & Bepalingen. <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b923970005 = messageFormatterFn((function(  ) {
  return function(d) { return "Voorwaarden van toepassing, links beschikbaar op het einde van de pagina"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1067440839 = messageFormatterFn((function(  ) {
  return function(d) { return "Controleer je inbox!"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a46573022 = messageFormatterFn((function(  ) {
  return function(d) { return "Reset je wachtwoord met de link die we hebben gestuurd naar " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b179072661 = messageFormatterFn((function(  ) {
  return function(d) { return "Link opnieuw versturen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a32298721 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er deed zich een interne fout voor"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1558794236 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer het opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b218475617 = messageFormatterFn((function(  ) {
  return function(d) { return "Terug"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1867457727 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een nieuwe link verstuurd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1592119707 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan bij " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1527735596 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan bij"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1680856638 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan met je e-mailadres"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b248601263 = messageFormatterFn((function(  ) {
  return function(d) { return "Of maak een account aan met je e-mailadres"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1665507255 = messageFormatterFn((function(  ) {
  return function(d) { return "Voor- en achternaam"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1792772131 = messageFormatterFn((function(  ) {
  return function(d) { return "Achter- en voornaam"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1388504062 = messageFormatterFn((function(  ) {
  return function(d) { return "Dient tussen 8 en 30 tekens lang te zijn en mag geen spaties bevatten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a522917596 = messageFormatterFn((function(  ) {
  return function(d) { return "Account aanmaken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1002931861 = messageFormatterFn((function(  ) {
  return function(d) { return "Heb je al een account?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b506522657 = messageFormatterFn((function(  ) {
  return function(d) { return "Door een account aan te maken, ga ik akkoord met de " + d["0"] + "gebruiksvoorwaarden van <a href=\"" + d["1"] + "\" target=\"_blank\">, <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a> het <a href=\"" + d["2"] + "\" target=\"_blank\">Privacybeleid, <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a> en de <a href=\"" + d["3"] + "\" target=\"_blank\">Voorwaarden & Bepalingen van " + d["4"] + ". <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b329575930 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik wil e-mails ontvangen met reisaanbiedingen, speciale deals en andere informatie."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a396998224 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben je een e-mail met een link gestuurd om het aanmaken van je account te voltooien. "; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1153566917 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik op de link in de e-mail die naar " + d["0"] + " is verstuurd om het aanmaken van je account te voltooien."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1728468998 = messageFormatterFn((function(  ) {
  return function(d) { return "Reset je wachtwoord"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b199575424 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je e-mailadres in en wij sturen je een link om je wachtwoord te resetten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1624820982 = messageFormatterFn((function(  ) {
  return function(d) { return "Resetlink sturen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b921825210 = messageFormatterFn((function(  ) {
  return function(d) { return "of als gast afrekenen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1216534676 = messageFormatterFn((function(  ) {
  return function(d) { return "Kies een nieuw wachtwoord"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b598277741 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een nieuw wachtwoord aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b593056818 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadres: " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1225692996 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord opslaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2056188342 = messageFormatterFn((function(  ) {
  return function(d) { return "Deze link is helaas niet meer geldig"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a530597515 = messageFormatterFn((function(  ) {
  return function(d) { return "Vraag een nieuwe link aan voor het resetten van je wachtwoord."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1409246411 = messageFormatterFn((function(  ) {
  return function(d) { return "Nieuwe resetlink sturen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a583596044 = messageFormatterFn((function(  ) {
  return function(d) { return "Terug naar Aanmelden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b926062475 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben je via e-mail een nieuwe link gestuurd om je wachtwoord te resetten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1361961418 = messageFormatterFn((function(  ) {
  return function(d) { return "Wat is je e-mailadres?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b862670193 = messageFormatterFn((function(  ) {
  return function(d) { return "Geef een e-mailadres op waarop je reisaanbieders of " + d["0"] + " je kunnen bereiken. We sturen je een beveiligingscode om je identiteit te verifiëren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a793654626 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt je " + d["0"] + "-account met een telefoonnummer aangemaakt. Verstrek een e-mailadres zodat we je registratie kunnen voltooien. We sturen je een beveiligingscode om je identiteit te verifiëren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a410257557 = messageFormatterFn((function(  ) {
  return function(d) { return "Beveiligingscode verzenden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1399401127 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer beveiligingscode in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1938817457 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de beveiligingscode in die we naar " + d["0"] + " hebben verstuurd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2144387774 = messageFormatterFn((function(  ) {
  return function(d) { return "Beveiligingscode"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1943862308 = messageFormatterFn((function(  ) {
  return function(d) { return "Indienen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1193333658 = messageFormatterFn((function(  ) {
  return function(d) { return "Geen e-mail ontvangen?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b92303510 = messageFormatterFn((function(  ) {
  return function(d) { return "Nieuwe beveiligingscode verzenden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a884096945 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een nieuwe beveiligingscode via e-mail naar je verstuurd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1156712948 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een geldige beveiligingscode in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1256393125 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt te vaak geprobeerd om de beveiligingscode opnieuw te verzenden. Probeer het na 24 uur opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b219373799 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt te vaak geprobeerd om de juiste beveiligingscode in te voeren. Probeer het na 24 uur opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b511730920 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de juiste beveiligingscode in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1685872324 = messageFormatterFn((function(  ) {
  return function(d) { return "Het door jou ingevoerde e-mailadres is al gebruikt om met " + d["1"] + " een account bij " + d["0"] + " aan te maken. Probeer je aan te melden met het " + d["1"] + "-account dat aan dat e-mailadres gekoppeld is."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b574595683 = messageFormatterFn((function(  ) {
  return function(d) { return "Om je account veilig te houden, dien je je wachtwoord te resetten voordat je je kan aanmelden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b105493113 = messageFormatterFn((function(  ) {
  return function(d) { return "Als je een account bij " + d["0"] + " hebt, sturen we je een e-mail met een link om je wachtwoord te resetten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1037136388 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom terug, " + d["0"] + "!"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b407160266 = messageFormatterFn((function(  ) {
  return function(d) { return "Je nieuwe wachtwoord is opgeslagen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1472554580 = messageFormatterFn((function(  ) {
  return function(d) { return "Verder boeken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1394527674 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom " + d["0"] + "!"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a575293000 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er deed zich een interne fout voor"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1854736217 = messageFormatterFn((function(  ) {
  return function(d) { return "Corrigeer de " + d["0"] + " onderstaande fouten om door te gaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a219327518 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt een onbekend e-mailadres of onjuist wachtwoord ingevoerd"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b327611370 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, we konden geen verbinding maken met " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1084093877 = messageFormatterFn((function(  ) {
  return function(d) { return "Je resetlink is helaas verlopen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a954996219 = messageFormatterFn((function(  ) {
  return function(d) { return "Vraag een nieuwe link aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a48072065 = messageFormatterFn((function(  ) {
  return function(d) { return "Je sessie is helaas verlopen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1432327799 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je voor- en achternaam in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b250913473 = messageFormatterFn((function(  ) {
  return function(d) { return "Voor je achter- en voornaam in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a271695949 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een naam in die alleen uit letters bestaat"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1995480957 = messageFormatterFn((function(  ) {
  return function(d) { return "Er bestaat al een account op " + d["0"] + " met dit e-mailadres  "; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a17116855 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord mag geen spaties bevatten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1466420584 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord mag niet overeenkomen met je e-mailadres."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1539594132 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit wachtwoord kan makkelijk geraden worden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1593979155 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit e-mailadres is al in gebruik"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a559469594 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord is vereist."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1251995872 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit wachtwoord is onjuist."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a905244292 = messageFormatterFn((function(  ) {
  return function(d) { return "Je wachtwoord dient uit minstens " + d["0"] + " tekens te bestaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a248328242 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord dient " + d["0"] + " tot " + d["1"] + " tekens te bevatten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b494545442 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit e-mailadres is al gebruikt om een account bij " + d["0"] + " aan te maken met " + d["1"] + ". Gebruik een ander e-mailadres of meld je aan met het " + d["1"] + "-account dat aan dit e-mailadres gekoppeld is"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b669540786 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, we kunnen je Apple ID niet gebruiken om in te loggen. We werken eraan om Apple ID's te ondersteunen die uit telefoonnummers bestaan. Meld je ondertussen aan via een andere methode."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a270990172 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit account kan niet gevonden worden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1199558109 = messageFormatterFn((function(  ) {
  return function(d) { return "Een e-mailadres is vereist."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1734737548 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1221951254 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1496181297 = messageFormatterFn((function(  ) {
  return function(d) { return "Terug naar de vorige pagina"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a195100696 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailvalidatie sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a920150690 = messageFormatterFn((function(  ) {
  return function(d) { return "Invoervenster voor CVV-code sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1088202260 = messageFormatterFn((function(  ) {
  return function(d) { return "Voltooi je boeking als gast of meld je aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a349647798 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik ben een nieuwe klant"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1225031403 = messageFormatterFn((function(  ) {
  return function(d) { return "Je kan na het afrekenen ook nog een account aanmaken."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a608218580 = messageFormatterFn((function(  ) {
  return function(d) { return "Als gast afrekenen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1921076104 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik ben een terugkerende klant"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1756998904 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan om punten met je boeking te sparen en punten voor je boeking te gebruiken."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b866988895 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden en afrekenen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a8159290 = messageFormatterFn((function(  ) {
  return function(d) { return "Of ga verder met"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a92011072 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom terug!"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1768335257 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan of maak een account aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a816631396 = messageFormatterFn((function(  ) {
  return function(d) { return "Doorgaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1472901794 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een link voor het opnieuw instellen van je wachtwoord verzonden naar " + d["0"] + ". Het kan een paar minuten duren voor je de link ontvangt. Controleer je map met ongewenste e-mail of spam als je de e-mail niet in je inbox ziet."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1673069291 = messageFormatterFn((function(  ) {
  return function(d) { return "Stel je wachtwoord opnieuw in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1827289539 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik 8 of meer tekens voor je wachtwoord."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1444984909 = messageFormatterFn((function(  ) {
  return function(d) { return "Ga verder met een gelinkt account"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2109742691 = messageFormatterFn((function(  ) {
  return function(d) { return "of stel een wachtwoord in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a630372845 = messageFormatterFn((function(  ) {
  return function(d) { return "Controleer je inbox!"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1649991052 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een verificatielink naar " + d["0"] + " verzonden zodat je je accountwachtwoord kan instellen. Het kan een paar minuten duren voor je de link ontvangt. Controleer je map met ongewenste e-mail of spam als je de e-mail niet in je inbox ziet."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b79384584 = messageFormatterFn((function(  ) {
  return function(d) { return "Stel een wachtwoord in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a84807310 = messageFormatterFn((function(  ) {
  return function(d) { return "Bewerken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a809531728 = messageFormatterFn((function(  ) {
  return function(d) { return "Het lijkt erop dat je al eerder bij ons geboekt hebt. Om veiligheidsredenen dienen we je e-mailadres te verifiëren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b104002190 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik de verificatielink die we naar " + d["0"] + " verzonden hebben om het aanmaken van je account te voltooien. Het kan een paar minuten duren voor je de link ontvangt. Controleer je map met ongewenste e-mail of spam als je de e-mail niet in je inbox ziet."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a71942356 = messageFormatterFn((function(  ) {
  return function(d) { return "Mijn reizigersdetails"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b636370169 = messageFormatterFn((function(  ) {
  return function(d) { return "Mijn accountdetails"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1864595853 = messageFormatterFn((function(  ) {
  return function(d) { return "Update persoonlijke gegevens en pas voorkeuren aan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2059162973 = messageFormatterFn((function(  ) {
  return function(d) { return "TSA-informatie"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2099083839 = messageFormatterFn((function(  ) {
  return function(d) { return "Voeg het Known Traveler- of redress-nummer toe."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b295554351 = messageFormatterFn((function(  ) {
  return function(d) { return "Persoonlijke gegevens"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1379476021 = messageFormatterFn((function(  ) {
  return function(d) { return "Deel basis- en contactgegevens."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1230468660 = messageFormatterFn((function(  ) {
  return function(d) { return "Vluchtvoorkeuren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b884524176 = messageFormatterFn((function(  ) {
  return function(d) { return "Pas de instellingen aan om je ervaring te personaliseren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1237316933 = messageFormatterFn((function(  ) {
  return function(d) { return "Loyaliteitsprogramma’s"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1536334935 = messageFormatterFn((function(  ) {
  return function(d) { return "Sla je frequent flyer en lidmaatschappen op"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a578667981 = messageFormatterFn((function(  ) {
  return function(d) { return "Paspoort"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1604725297 = messageFormatterFn((function(  ) {
  return function(d) { return "Sla je paspoort op om het boekingsproces te versnellen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1486790 = messageFormatterFn((function(  ) {
  return function(d) { return "Apparatuurbeheer"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a409055466 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekijk je aangemelde apparaten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b691496082 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden om je account te bekijken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a372312501 = messageFormatterFn((function(  ) {
  return function(d) { return "Account aanmaken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a245437036 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er is bij ons iets misgegaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1873907927 = messageFormatterFn((function(  ) {
  return function(d) { return "Ben je offline? Controleer je internetverbinding en probeer het opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b619865519 = messageFormatterFn((function(  ) {
  return function(d) { return "Opnieuw proberen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b693205886 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezig met laden ..."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a673298727 = messageFormatterFn((function(  ) {
  return function(d) { return "1 nacht"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1147043857 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " nachten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a250671899 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed, 1 nacht geselecteerd. Sla de wijzigingen op en sluit de kalender."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a665329251 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed, " + d["0"] + " nachten geselecteerd. Sla de wijzigingen op en sluit de kalender."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1560097952 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a479704009 = messageFormatterFn((function(  ) {
  return function(d) { return "er zijn " + d["0"] + " resultaten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1528358015 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is 1 resultaat"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a542128832 = messageFormatterFn((function(  ) {
  return function(d) { return "Deze content is betaald door " + d["0"] + " en gemaakt door Expedia Group Media Studio. De redactie van de bedrijven van Expedia Group heeft geen rol gespeeld bij de totstandkoming van deze content."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1630268643 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1127407543 = messageFormatterFn((function(  ) {
  return function(d) { return "Vlucht"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1076815349 = messageFormatterFn((function(  ) {
  return function(d) { return "Pakket"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a202244099 = messageFormatterFn((function(  ) {
  return function(d) { return "Auto"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b450992652 = messageFormatterFn((function(  ) {
  return function(d) { return "Activiteiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1416407533 = messageFormatterFn((function(  ) {
  return function(d) { return "Cruises"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b282768579 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b2007842098 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"y-MM-dd","timeSeparator":":"});
Globalize.b1397314947 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1431703459 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"dd/MM/yy","timeSeparator":":"});
Globalize.a1616303182 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"dd/MM/y","timeSeparator":":"});
Globalize.b1418689565 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"d/MM/yy","timeSeparator":":"});
Globalize.b521137648 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b282189648 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"d/M/yy","timeSeparator":":"});
Globalize.b147731045 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d/M/y","timeSeparator":":"});
Globalize.b1643591606 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a2090922011 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"y/M/d","timeSeparator":":"});
Globalize.b1343173923 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a347121853 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"dd.MM.yy","timeSeparator":":"});
Globalize.b127430674 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"dd.MM.y","timeSeparator":":"});
Globalize.b1235389528 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"d.MM.y","timeSeparator":":"});
Globalize.b2067434478 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b2053629134 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"d.M.yy","timeSeparator":":"});
Globalize.b1036158247 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d.M.y","timeSeparator":":"});
Globalize.a454548093 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1270525426 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"y/MM/dd","timeSeparator":":"});
Globalize.b1289032899 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a2125947165 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"dd-MM-yy","timeSeparator":":"});
Globalize.b759538627 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b762709040 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b2061593891 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b500296958 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"Z","mon":"M","tue":"D","wed":"W","thu":"D","fri":"V","sat":"Z"}}}});
Globalize.a1646398525 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"zondag","mon":"maandag","tue":"dinsdag","wed":"woensdag","thu":"donderdag","fri":"vrijdag","sat":"zaterdag"}}}});
Globalize.a393153085 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b2067027005 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1572305520 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a951232081 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b595937704 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a762821469 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1222379485 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1221694292 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b35181039 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"zondag","mon":"maandag","tue":"dinsdag","wed":"woensdag","thu":"donderdag","fri":"vrijdag","sat":"zaterdag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b603325872 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"zo","mon":"ma","tue":"di","wed":"wo","thu":"do","fri":"vr","sat":"za"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a95945172 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1256559721 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"y-MM-dd"}));
Globalize.b1018601196 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a383213748 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd/MM/yy"}));
Globalize.b1927381737 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd/MM/y"}));
Globalize.b667407188 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d/MM/yy"}));
Globalize.a1293779559 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b673596729 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d/M/yy"}));
Globalize.b298904412 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d/M/y"}));
Globalize.a171325601 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a1939748644 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"y/M/d"}));
Globalize.b964460172 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b2132928236 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd.MM.yy"}));
Globalize.a623851703 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd.MM.y"}));
Globalize.b1626796609 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d.MM.y"}));
Globalize.b252517271 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1849931081 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d.M.yy"}));
Globalize.b1187331614 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d.M.y"}));
Globalize.a833261844 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b519243049 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"y/MM/dd"}));
Globalize.b910319148 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b354102924 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd-MM-yy"}));
Globalize.b380824876 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1052208167 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b1682880140 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b651470325 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a810237972 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b443007468 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b1483743412 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d"}));
Globalize.a1180898439 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1379090650 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b217223953 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b381954138 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b843665734 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b842980541 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b652911590 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b224612121 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1710006915 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b727834296 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y-MM-dd","digitsRe":/\d/});
Globalize.a595460547 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b406167261 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yy","digitsRe":/\d/});
Globalize.b1398656312 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/y","digitsRe":/\d/});
Globalize.b138681763 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/MM/yy","digitsRe":/\d/});
Globalize.a504398550 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b517993738 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yy","digitsRe":/\d/});
Globalize.a1507230357 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/y","digitsRe":/\d/});
Globalize.b618055408 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b549083883 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y/M/d","digitsRe":/\d/});
Globalize.a649601571 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1372658051 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yy","digitsRe":/\d/});
Globalize.a1152577128 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.y","digitsRe":/\d/});
Globalize.b1471193618 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.MM.y","digitsRe":/\d/});
Globalize.b1041898280 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a2005534072 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yy","digitsRe":/\d/});
Globalize.a618803155 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.y","digitsRe":/\d/});
Globalize.b1847643709 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a9482376 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y/MM/dd","digitsRe":/\d/});
Globalize.a703742595 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1143483933 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yy","digitsRe":/\d/});
Globalize.a1233236867 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a262827158 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b68818397 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1154664444 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^Z/],["mon",/^M/],["tue",/^D/],["wed",/^W/],["thu",/^D/],["fri",/^V/],["sat",/^Z/]]});
Globalize.b101330941 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^donderdag/],["wed",/^woensdag/],["sat",/^zaterdag/],["mon",/^maandag/],["tue",/^dinsdag/],["fri",/^vrijdag/],["sun",/^zondag/]]});
Globalize.b1354576381 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.a1253436861 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1336501430 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1616884149 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
Globalize.a1396837790 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.b1885647657 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.a770396009 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.a771081202 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
Globalize.a1701595403 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^donderdag/],["wed",/^woensdag/],["sat",/^zaterdag/],["mon",/^maandag/],["tue",/^dinsdag/],["fri",/^vrijdag/],["sun",/^zondag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
Globalize.a1389449622 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^zo/],["mon",/^ma/],["tue",/^di/],["wed",/^wo/],["thu",/^do/],["fri",/^vr/],["sat",/^za/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
module.exports = Globalize;
